import React from 'react';
import { makeStyles } from '@mui/styles';
import Popover from '@mui/material/Popover';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import { Grid, Box } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

export default function SimplePopover(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div style={{...props.style, position: 'absolute', right:props.positionRight || 8, top: props.positionTop || -12, backgroundColor:'#fff', zIndex:10 }}>
      <IconButton aria-describedby={id} variant="contained" onClick={handleClick} style={{width:24,height:24}}>
        <InfoIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}

      >
        <Grid container style={{maxWidth:600}}>
          <Grid item xs={12} sm={12}>
          <Box p={2}><div dangerouslySetInnerHTML={{ __html: props.content }}></div> </Box>
          </Grid>
        </Grid>
      </Popover>
    </div>
  );
}
